// extracted by mini-css-extract-plugin
export default {"container":"page-not-found_container__LMk1q"};